module.exports = __webpack_public_path__ + "media/nicole1.263656ef.mp3";